import React from 'react';

const SectionDivider = ({ white }) => {
  return <div className={`section-divider${white ? '--white' : ''}`} />;
};

export default SectionDivider;
